// スクロールで表示：[data-c-reveal] の要素を、画面に入ったときに下からふわっと出す
// 動きは Why We're Your Pearl Experts（multi-column の stagger-apparition）と同じ。同時に入った要素は 0.1 秒ずつずらす
// テーマエディタの中では、セクション側でこのファイルを読み込まない
(() => {
  if (window.cRevealLoaded) {
    return;
  }
  window.cRevealLoaded = true;

  const DURATION = 600;
  const STAGGER = 100;

  const showAll = (items) => {
    items.forEach((item) => item.classList.add('is-revealed'));
  };

  const init = () => {
    const items = Array.from(document.querySelectorAll('[data-c-reveal]:not(.is-revealed)'));
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduced || !('IntersectionObserver' in window) || !Element.prototype.animate) {
      showAll(items);
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      const visible = entries.filter((entry) => entry.isIntersecting);
      const offset = window.innerWidth < 1000 ? 35 : 60;

      visible.forEach((entry, index) => {
        const item = entry.target;
        observer.unobserve(item);
        // 待っている間は1コマ目（透明・下）を保つ
        item.animate(
          [
            { opacity: 0, transform: `translateY(${offset}px)` },
            { opacity: 1, transform: 'translateY(0)' },
          ],
          { duration: DURATION, delay: STAGGER * index, easing: 'ease', fill: 'backwards' },
        );
        item.classList.add('is-revealed');
      });
    }, { rootMargin: '0px 0px -50px 0px' });

    items.forEach((item) => observer.observe(item));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
